import { getAssetURL } from "src/helpers";

import { ADMIN_APP_ASSET_PATHS } from "./assets";

export const LIST_INDUSTRIES = [
  'Animals & Pet Supplies',
  'Apparel & Accessories',
  'Arts & Entertainment',
  'Baby & Toddler',
  'Business & Industrial',
  'Cameras & Optics',
  'Electronics',
  'Food, Beverages & Tobacco',
  'Furniture',
  'Hardware',
  'Health & Beauty',
  'Home & Garden',
  'Luggage & Bags',
  'Mature',
  'Media',
  'Office Supplies',
  'Religious & Ceremonial',
  'Software',
  'Sporting Goods',
  'Toys & Games',
  'Vehicles & Parts'
];

export const NEW_ONBOARDING_SSR_USER = '2024-03-06T00:00:01+00:00'; //'2024-03-06T14:39:48+07:00';

export const DATA_DEFAULT_INDUSTRIES = [
  {
    value: 'Apparel & Accessories',
    label: 'Apparel & Accessories'
  },
  {
    value: 'Home & Garden',
    label: 'Home & Garden'
  },
  {
    value: 'Health & Beauty',
    label: 'Health & Beauty'
  },
  {
    value: 'Sporting Goods',
    label: 'Sporting Goods'
  },
  {
    value: 'Food, Beverages & Tobacco',
    label: 'Food, Beverages & Tobacco'
  },
  {
    value: 'Baby & Toddler',
    label: 'Baby & Toddler'
  }
];

export const DATA_PLUGIN = [
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.iconFilter),
    title: 'AdminHTML.InstallationV2.KYC.step1_filter_title',
    description: 'AdminHTML.InstallationV2.KYC.step1_filter_description',
    value: 'PRODUCT_FILTER',
    hover: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.featureFilter2X)
  },
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.iconSearch),
    title: 'AdminHTML.InstallationV2.KYC.step1_search_title',
    description: 'AdminHTML.InstallationV2.KYC.step1_search_description',
    value: 'PRODUCT_SEARCH',
    hover: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.featureSearch2X)
  },
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.iconVisual),
    title: 'AdminHTML.InstallationV2.KYC.step1_visual_title',
    description: 'AdminHTML.InstallationV2.KYC.step1_visual_description',
    value: 'VISUAL_MERCHANDISING',
    hover: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.featureVisual2X)
  },
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.iconRecommendation),
    title: 'AdminHTML.InstallationV2.KYC.step1_recommendation_title',
    description: 'AdminHTML.InstallationV2.KYC.step1_recommendation_description',
    value: 'PRODUCT_RECOMMENDATION',
    hover: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.featureRecommendation2X)
  }
];

export const DATA_REVENUE = [
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_1',
    value: 'lessThan0'
  },
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_2',
    value: 'from1To10'
  },
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_3',
    value: 'from10To15'
  },
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_4',
    value: 'above15'
  },
  {
    label: 'AdminHTML.InstallationV2.KYC.step3_revenue_5',
    value: 'notSay'
  }
];

export const DATA_ONBOARDING = [
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.onboarding12X),
    title: 'AdminHTML.InstallationV2.Onboarding.step1_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step1_description',
    value: 'onboarding_step1'
  },
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.onboarding22X),
    title: 'AdminHTML.InstallationV2.Onboarding.step2_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step2_description',
    value: 'onboarding_step2'
  },
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.onboarding32X),
    title: 'AdminHTML.InstallationV2.Onboarding.step3_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step3_description',
    value: 'onboarding_step3'
  },
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.onboarding42X),
    title: 'AdminHTML.InstallationV2.Onboarding.step4_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step4_description',
    value: 'onboarding_step4'
  },
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.onboarding52X),
    title: 'AdminHTML.InstallationV2.Onboarding.step5_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step5_description',
    value: 'onboarding_step5'
  },
  {
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.installation?.onboarding62X),
    title: 'AdminHTML.InstallationV2.Onboarding.step6_title',
    description: 'AdminHTML.InstallationV2.Onboarding.step6_description',
    value: 'onboarding_step6'
  }
];

export const DEFAULT_SELECT_FEATURE_ON_THEME_SETUP_ONBOARDING = {
  PRODUCT_FILTER: ['filterCollection', 'filterSearch'],
  PRODUCT_SEARCH: ['instantSearch'],
  VISUAL_MERCHANDISING: ['instantSearch'],
  PRODUCT_RECOMMENDATION: ['recommendation']
};

export const getFeatureByFeatureInterestKYC = (features, isOldUser) => {
  if (!features.length && isOldUser) {
    return {
      filterCollection: true,
      filterSearch: true,
      instantSearch: true,
      recommendation: true
    };
  }
  const allFeatures = [];
  features.forEach(feature => {
    const feat = DEFAULT_SELECT_FEATURE_ON_THEME_SETUP_ONBOARDING[feature];
    if (feat) {
      allFeatures.push(...feat);
    }
  });
  const data = [...new Set(allFeatures)];
  const objFeature = {
    filterCollection: data.includes('filterCollection'),
    filterSearch: data.includes('filterSearch'),
    instantSearch: data.includes('instantSearch'),
    recommendation: data.includes('recommendation')
  };

  return objFeature;
};

export const TURBO_FEATURE = {
  COLLECTION_FILTER: 'collectionPage',
  SEARCH_PAGE_FILTER: 'searchPage',
  ISW: 'isw'
}

export const TURBO_WIDGET_FEATURES = [
  {
    featureId: TURBO_FEATURE.COLLECTION_FILTER,
    name: 'Collection page with filters',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature01_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboard?.onboarding?.collectionFeature4x)
  },
  {
    featureId: TURBO_FEATURE.SEARCH_PAGE_FILTER,
    name: 'Search page with filters',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature02_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboard?.onboarding?.searchWithFilterFeature4x)
  },
  {
    featureId: TURBO_FEATURE.ISW,
    name: 'Instant search widget',
    content: 'AdminHTML.ShopifyIntegration.Onboarding.step03_Feature03_Content',
    img: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboard?.onboarding?.iswFeature4x)
  }
];

export const TURBO_FEATURE_OPTIONS = [
  {
    label: 'AdminHTML.InstallationV2.SelectTheme.step2_option1',
    value: TURBO_FEATURE.COLLECTION_FILTER
  },
  {
    label: 'AdminHTML.InstallationV2.SelectTheme.step2_option2',
    value: TURBO_FEATURE.SEARCH_PAGE_FILTER
  },
  {
    label: 'AdminHTML.InstallationV2.SelectTheme.step2_option3',
    value: TURBO_FEATURE.ISW
  }
]

export const INSTALL_STATUS = {
  ACCEPTED_PERMISSION: 'accepted-permissions',
  SUBMITTED_KYC: 'submitted-kyc',
  SUBMITTED_ONBOARDING: 'submitted-onboarding',
  SUBMITTED_ONBOARDING_SIMPLIFY: 'submitted-onboarding-simplify',
  SUBMITTED_ONBOARDING_PLAN: 'submitted-onboarding-plan'
}
